export default __webpack_public_path__ + "static/media/storageUnit1-afterD-1440w.6aba1406.webp";